











































import { Vue, Component, Prop } from "vue-property-decorator"; // eslint-disable-line no-unused-vars
import CdkFilterPassBadges from "../../CdkFilterPassBadge/CdkFilterPassBadges.vue"; // eslint-disable-line no-unused-vars
import { FilterPassBadge } from "@/utils/filterPassBadges";
import ImageContent from "../ContentRows/ImageContent.vue";
import TextContent from "../ContentRows/TextContent.vue";

@Component({
  components: {
    CdkFilterPassBadges,
    ImageContent,
    TextContent
  }
})
export default class SlcNewsItemLong extends Vue {
  @Prop({
    type: String,
    required: true
  })
  date!: string;

  @Prop({
    type: String,
    required: true
  })
  time!: string;

  @Prop({
    type: Array,
    required: false
  })
  tags?: any[]; // NB: Tags are not displayed in "compact" ticker view

  @Prop({
    type: String,
    required: false,
    default: ""
  })
  genre?: string;

  @Prop({
    type: String,
    required: true
  })
  title!: string;

  @Prop({
    type: String,
    required: false
  })
  description?: string;

  @Prop({
    type: Number,
    required: false
  })
  wordCount?: number;

  @Prop({
    type: String,
    required: true
  })
  guid!: string;

  @Prop({
    type: String,
    required: false,
    default: ""
  })
  pubStatus?: string;

  @Prop({
    type: Boolean,
    required: false,
    default: false
  })
  isUrgent?: boolean;

  @Prop({
    type: Boolean,
    required: false,
    default: false
  })
  isEmbargoed?: boolean;

  @Prop({
    type: Boolean,
    default: false,
    required: false
  })
  isCompact?: boolean;

  @Prop({
    type: String,
    required: false,
    default: ""
  })
  embargoed?: string;

  @Prop({
    type: Array,
    required: false,
    default: () => []
  })
  filterPassBadges?: FilterPassBadge[];

  @Prop({
    type: String,
    required: false
  })
  residref?: string | null;

  @Prop({
    type: String,
    required: false
  })
  layoutOrientation?: string | null;

  @Prop({
    type: Boolean,
    default: false
  })
  showNewBadge: boolean;

  get contentProps() {
    const base = {
      genre: this.genre,
      embargoed: this.embargoed,
      isEmbargoed: this.isEmbargoed,
      title: this.title,
      description: this.description,
      isCompact: this.isCompact,
      filterPassBadges: this.filterPassBadges
    };

    if (this.residref) {
      return {
        ...base,
        guid: this.guid,
        residref: this.residref,
        layoutOrientation: this.layoutOrientation
      };
    }

    return { ...base };
  }

  get contentComponent() {
    if (this.residref) {
      return ImageContent;
    }
    return TextContent;
  }
}
